<div class="row">
    <!-- Page Heading and Buttons -->
    <div class="col-6">
        <h2>Holiday's List</h2>
    </div>
    <div class="col-6">
        <button type="button" class="btn btn-primary px-4" style="float: right;" (click)="onAddHoliday()">
            Add Holiday
        </button>
    </div>
</div>

<div class="col-12 mt-4">
    <!-- Holiday Listing Table -->
    <nb-card class="custom-card">
        <nb-card-body>
            <table class="table text-center">
                <thead>
                    <tr>
                        <th scope="col">S.No.</th>
                        <th scope="col">Holiday Name</th>
                        <th scope="col">Date</th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let holiday of holidays| paginate : { itemsPerPage: 10, currentPage: page, totalItems: total };let i = index">
                        <td>{{(page - 1) * count + i + 1 + ((page - 1) * count)}}</td>
                        <td>{{ holiday.name }}</td>
                        <td>{{ holiday.date | date: 'dd/MM/yyyy' }}</td>
                        <td>
                            <nb-icon style="cursor: pointer;" (click)="editAdmin(holiday._id)" class="right"
                                icon="edit-outline"></nb-icon> <nb-icon style="cursor: pointer;"
                                (click)="deleteAdmin(holiday._id)" class="right deleteIcon"
                                icon="trash-outline"></nb-icon>
                        </td>
                    </tr>
                </tbody>
            </table>
        </nb-card-body>
    </nb-card>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
    [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>